import { THEME_IDS } from '@whistler-ui/k2/constants';
import { getMode } from '@whistler-ui/k2/constants/settings';

export const API_ENDPOINTS = {
  // HTTP Agents
  INBOUND_URL: import.meta.env.REACT_APP_INBOUND_URL || '/',
  ACCOUNTS: import.meta.env.REACT_APP_API_ENDPOINT_ACCOUNTS || '/',
  ENVIRONMENT: import.meta.env.REACT_APP_API_ENDPOINT_ENVIRONMENT || '/',
  REPORTING: import.meta.env.REACT_APP_API_ENDPOINT_REPORTING || '/',
  RESOURCES: import.meta.env.REACT_APP_API_ENDPOINT_RESOURCES || '/',
  TESTS_EXECUTION: import.meta.env.REACT_APP_API_ENDPOINT_TESTS_EXECUTION,
  UPLOAD: import.meta.env.REACT_APP_API_ENDPOINT_UPLOAD || '/',
  USE_CASES: import.meta.env.REACT_APP_API_ENDPOINT_USE_CASES || '/',
  WEBSHEET_CONFIG:
    import.meta.env.REACT_APP_API_ENDPOINT_WEBSHEET_CONFIG || '/',
  // Others
  PUBLIC_URL: import.meta.env.REACT_APP_PUBLIC_URL || '/',
  WEBSHEET_URL: import.meta.env.REACT_APP_WEBSHEET_URL || '/',
  AI_AGENT_URL: import.meta.env.REACT_APP_AI_AGENT_URL || '/',
  AI_SUBSCRIBER_LOGS_WEBHOOK_ID:
    import.meta.env.REACT_APP_AI_SUBSCRIBER_LOGS_WEBHOOK_ID || '',
  AI_DOC_ASSISTANT_WEBHOOK_ID:
    import.meta.env.REACT_APP_AI_DOC_ASSISTANT_WEBHOOK_ID || '',
  AI_REPORTS_WEBHOOK_ID: import.meta.env.REACT_APP_AI_REPORTS_WEBHOOK_ID || '',
} as const;

export const SETTINGS = {
  THEME_ID: import.meta.env.REACT_APP_THEME_ID || THEME_IDS.NETLYNC,
  HOTJAR_ID: import.meta.env.REACT_APP_HOTJAR_ID,
  GOOGLE_ANALYTICS_ID: import.meta.env.REACT_APP_GOOGLE_ANALYTICS,
  HASH_VERSION: import.meta.env.REACT_APP_HASH_COMMIT,
  REACT_APP_SITE_REGION: import.meta.env.REACT_APP_SITE_REGION,
  REACT_APP_SENTRY_ENV: import.meta.env.REACT_APP_SENTRY_ENV,
  ...getMode(),
  API_ENDPOINTS,
  ...API_ENDPOINTS,
} as const;

export const ROLES = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  DEVELOPER: 'DEVELOPER',
  FINANCE: 'FINANCE',
  SUPPORT: 'SUPPORT',
  PARTNER_CARRIER: 'PARTNER_CARRIER',
  GROUP_ADMINISTRATOR: 'GROUP_ADMINISTRATOR',
  GROUP_USER: 'GROUP_USER',
} as const;

export const WATCH_CONTRACT_BRIDGEKEEPER_KEY = 'watch-contract-summary';

export const FAMILY_PLAN_BRIDGEKEEPER_KEY = 'family_plan';

// Gates the VoWiFi Google Places autocomplete rollout (UES-11808): the
// activation-page checkbox and the autocomplete/validation localisation groups.
export const EMERGENCY_ADDRESS_AUTOCOMPLETE_BRIDGEKEEPER_KEY =
  'emergency_address_autocomplete';

export const REPORTS_ANALYTICS_TYPES = {
  TRANSFER: 'transfer-analytics',
  WATCH: 'watch-analytics',
  RCS: 'rcs-analytics',
} as const;
